<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}
                </router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm7>
                <div class="form-group dropbox" v-if="!shop.imageUrl">
                  <button
                    v-if="shop.imageUrl"
                    style="float: right"
                    @click="removeImage"
                    class="close"
                    type="button"
                  >
                    <v-icon color="red">cancel</v-icon>
                  </button>
                  <input
                    type="file"
                    @change="onFileChanged"
                    class="input-file"
                  />
                  <p v-if="!shop.imageUrl">
                    Drag your file(s) here to begin
                    <br />or click to browse
                  </p>
                </div>
                <div v-if="shop.imageUrl">
                  <img :src="shop.imageUrl" width="600px" height="150px" />
                  <button
                    style="float: right"
                    @click="removeImage"
                    class="close"
                    type="button"
                  >
                    <v-icon color="red">cancel</v-icon>
                  </button>
                </div>
              </v-flex>
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="name"
                  label="Shop Name"
                  v-model="shop.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="code"
                  label="Shop Code"
                  v-model="shop.code"
                  type="text"
                  :rules="rules.codeRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="shop.cityId"
                  :items="cityList"
                  color="blue-grey lighten-2"
                  label="Choose City..."
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  :rules="rules.cityIdRules"
                  @change="getTownshipByCityId(shop.cityId)"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="shop.townshipId"
                  :items="townshipList"
                  color="blue-grey lighten-2"
                  label="Choose Township..."
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  :rules="rules.townshipIdRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="phoneNo"
                  label="PhoneNo"
                  v-model="shop.phoneNo"
                  type="text"
                  :rules="rules.phoneNoRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-select
                  :items="regionList"
                  label="Choose Region ..."
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  v-model="shop.regionId"
                ></v-select>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="address"
                  label="Address"
                  v-model="shop.address"
                  type="text"
                  :rules="rules.addressRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-select
                  :items="warehouseList"
                  label="Choose Warehouse ..."
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  @change="showBins()"
                  v-model="shop.warehouseId"
                  :rules="rules.warehouseRules"
                ></v-select>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="shop.binIds"
                  :items="binList"
                  color="blue-grey lighten-2"
                  label="Choose Bin..."
                  menu-props="auto"
                  item-text="name"
                  item-value="id"
                  :rules="rules.binListRules"
                  multiple
                  chips
                ></v-autocomplete>
              </v-flex>
              <v-flex sm6 v-if="shop.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="shop.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="shop.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="shop.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="shop.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="shop.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>

              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear" :disabled="user.roleName === 'PRODUCTION_MANAGER'">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid || user.roleName === 'PRODUCTION_MANAGER'"
                    type="submit"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";
import { ShopFormRules } from "../../helpers/validation-rules";
import { shopService } from "../../services/shop-service";
import { regionService } from "../../services/region-service";
import { warehouseService } from "../../services/warehouse-service";
import { Shop } from "../../models/model";
import { cityService } from "../../services/city-service";

export default {
  name: "ShopDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "Shop",
        disabled: false,
        to: "shops",
      },
      {
        text: "Shop Details",
        disabled: true,
      },
    ],
    warehouseList: [],
    binList: [],
    townshipList: [],
    cityList: [],
    regionList: [],
    createdDate: "",
    updatedDate: "",
    responseError: "",
    saveLoading: false,
    rules: new ShopFormRules(),
    shop: new Shop(),
    oldShop: new Shop(),
    messageDialogBox: false,
    queryParams: {
      status: "ACTIVE",
    },
  }),
  created() {
    this.getWarehouseList();
    this.getRegionList();
    const id = this.$route.params.id;
    if (id == "new") {
      // new Shop
    } else {
      this.getShopDetail(id);
    }
    this.getAllCity();
  },

  methods: {
    getWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    showBins() {
      this.shop.binIds = [];
      let warehouseId = this.shop.warehouseId;
      let warehouse = commonService.search(
        "id",
        warehouseId,
        this.warehouseList
      );
      this.binList = warehouse.binList;
    },

    getAllCity() {
      cityService.getAllCity().then((res) => {
        this.cityList = res.data.cityList;
      });
    },

    getTownshipByCityId(cityId) {
      cityService
        .getCityDetail(cityId)
        .then((res) => {
          this.townshipList = res.data.townships;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getRegionList() {
      regionService
        .getRegionsByStatus("ACTIVE")
        .then((res) => {
          this.regionList = res.data;
          let noregion = {
            id: "",
            name: "----No Region----",
          };
          this.regionList.splice(0, 0, JSON.parse(JSON.stringify(noregion)));
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getShopDetail(id) {
      shopService.getShopById(id).then((res) => {
        this.shop = res.data;
        if (!this.shop.regionId) this.shop.regionId = "";
        this.createdDate = commonService.formatDate(
          new Date(this.shop.createdDateInMilliSeconds)
            .toISOString()
            .substr(0, 10),
          "YYYY-MM-DD"
        );
        this.updatedDate = commonService.formatDate(
          new Date(this.shop.updatedDateInMilliSeconds)
            .toISOString()
            .substr(0, 10),
          "YYYY-MM-DD"
        );
        this.oldShop = Object.assign({}, res.data);
        if (this.shop.cityId) this.getTownshipByCityId(this.shop.cityId);

        let warehouseId = this.shop.warehouseId;
        warehouseService.getWarehouseDetail(warehouseId).then((res) => {
          this.binList = res.data.binList;
        });
      });
    },

    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;

        shopService
          .saveShop(this.shop)
          .then((res) => {
            console.log(res);
            this.goBack();
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
              this.messageDialogBox = true;
            }
            this.saveLoading = false;
          });
      }
    },

    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.shop.id) {
        this.shop = new Shop();
      } else {
        this.shop = Object.assign({}, this.oldShop);
      }
    },

    goBack() {
      this.$router.push("/shops");
    },

    removeImage() {
      this.shop.imageUrl = null;
    },

    onFileChanged(event) {
      const file = event.target.files[0];
      this.shop.imageUrl = URL.createObjectURL(file); // to show preview image
      commonService.getBase64(file).then((data) => {
        this.shop.image = data;
      });
    },
  },
};
</script>
